// extracted by mini-css-extract-plugin
export var askAiIcon = "_rj-9";
export var container = "_rj-0";
export var groupSeparator = "_rj-a";
export var highlight = "_rj-4";
export var resultIcon = "_rj-5";
export var resultItem = "_rj-7";
export var resultSubtitle = "_rj-3";
export var resultTitle = "_rj-2";
export var resultsList = "_rj-1";
export var searchGroup = "_rj-6";
export var selected = "_rj-8";